import { TelSysTypes } from '../../TelSysConfiguration/Constants/Constants'

export const CXI_FEATURE_FLAG_KEY_FOR_TELSYS: Record<TelSysTypes, string> = {
    [TelSysTypes.BROADSOFT_BROADWORKS]: 'enableCrmBroadworks',
    [TelSysTypes.WEBEX_CALLING]: 'enableCrmWebex',
    [TelSysTypes.MS_TEAMS]: 'enableCrmTeams'
} as Record<TelSysTypes, string>

export const NEW_CRADLE_TO_GRAVE_FEATURE_FLAG: string = 'enableNewCradleToGrave'
export const NEW_CALL_DETAILS_MEETINGS_FLAG: string = 'enableCallDetailsMeetings'
export const USE_NEW_ENTERPRISE_NAMES_FLAG: string = 'useNewEnterpriseLicenceNames'
export const SHOW_LICENCE_SUMMARY_FLAG: string = 'showLicenceSummary'
export const CX_AUDIT_MODE_FEATURE_FLAG: string = 'enableCxaAuditMode'
export const CX_SCORE_FEATURE_FLAG: string = 'enableCXScore'
export const DISABLE_NEW_USER_TUTORIAL_FLAG: string = 'disableNewUserTutorial'
export const ENABLE_NEW_USER_TOUR: string = 'newUserTour'
export const SITE_SURVEY_FEATURE_FLAG: string = 'enableSiteSurvey'
export const ENABLE_CXI_DATA: string = 'enableCxiData'
